// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  DialogHeader,
  Dialog,
  DialogBody,
} from '../core/src/components/common/Dialog';
import appStyles from '../config/appStyles.js';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => appStyles.changeCountryModal(theme));

const ChangeCountryModal = observer(
  ({ countries, countrySeleced, title, open, onClose }) => {
    const classes = useStyles();
    const location = useLocation();
    const selectNewCountry = (code) => {
      if (code !== countrySeleced?.code) {
        window.location.href = `/${code.toLowerCase()}${location.pathname}`;
      } else {
        onClose();
      }
    };

    return (
      <Dialog
        className={classes.modal}
        open={open}
        id="change-country-modal"
        maxWidth="md"
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
        PaperProps={{
          classes: {
            root: classes.paperProps,
          },
        }}>
        <DialogHeader
          title={title}
          onClose={onClose}
          className={classes.modalHeader}
        />
        <DialogBody className={classes.modalBody}>
          {(countries || []).map((country, index) => (
            <div
              key={index}
              className={classes.chooseCountryBox}
              onClick={() => selectNewCountry(country?.code)}>
              <img
                className={classes.flagImg}
                src={
                  country?.code
                    ? `https://cdn.deagostini.com/static/flags/${country.code.toLowerCase()}.svg`
                    : ''
                }
                alt={country?.name}
              />
              <span className={classes.flagLabel}>{country?.name}</span>
            </div>
          ))}
        </DialogBody>
      </Dialog>
    );
  },
);

export default ChangeCountryModal;
